export function entries<T extends { [key: string]: any }>(obj: T): [string, T[keyof T]][] {
  return Object.entries(obj) as [string, T[keyof T]][];
}

export function fromEntries<K extends string | number, V>(entries: [K, V][]): { [key in K]: V } {
  return Object.fromEntries(entries) as { [key in K]: V };
}